import { render, staticRenderFns } from "./Jumbo.vue?vue&type=template&id=50e3b9d5&scoped=true&"
import script from "./Jumbo.vue?vue&type=script&lang=js&"
export * from "./Jumbo.vue?vue&type=script&lang=js&"
import style0 from "./Jumbo.vue?vue&type=style&index=0&id=50e3b9d5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e3b9d5",
  null
  
)

export default component.exports